import React from 'react';
import Main from '../ContactUs/Main';
import MainSec2 from '../ContactUs/MianSec2';

export const ConatctUs = () => {
  return (
    <>
        <Main />
        <MainSec2 />
    </>
  );
};